<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi" :serial="serial" :searchBtnHide="!!$store.getters.cusId" :resetBtnHide="!!$store.getters.cusId"
        :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="handleOpen()">{{ $t('addText') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
              <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
                  <template slot-scope="scope">
                      <template v-if="false" />
                      <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
                  </template>
              </el-table-column>
              <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" class="edit-btn" @click="handleOpen(scope.row)">{{ $t('editText') }}</el-button>
                    <el-button type="text" class="edit-btn" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button>
                  </template>
              </el-table-column>
          </template>
        </template>
      </BjPage>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="title"
        :visible.sync="addDialogVisible"
        width="500px"
        :before-close="handleClose"
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item :label="$t('billingPage.department')" prop="department">
            <BjSelectLov v-model="form.department" :option-list="departList" />
          </el-form-item>
          <el-form-item :label="$t('billingPage.position')" prop="position">
            <BjInput v-model="form.position" :maxlength="50" :placeholder="$t('inputText')" />
          </el-form-item>
          <el-form-item v-if="$store.getters.userPermissionBtns.includes(permissionCode.toLocaleLowerCase())" :label="$t('billingPage.hourlyWage')" prop="hourlyWage">
            <BjInputMoney v-model="form.hourlyWage" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </template>

  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { userApi } from '@/api';
  export default {
      name: 'BusinessUserDepartPosition',
      mixins: [pageMiXin],
      data() {
          return {
              queryApi: userApi.getStationPage,
              // 查询参数
              queryParams: {},
              labelList: [
                  { label: this.$t('billingPage.department'), prop: 'department', isCheck: true, disabled: false },
                  { label: this.$t('billingPage.position'), prop: 'position', isCheck: true, disabled: false },
                  { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
              ],
              addDialogVisible: false,
              title: '',
              form: {department:null,position:null, hourlyWage: null},
              rules: {
                department: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
                position: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
                hourlyWage: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
              },
              permissionCode: 'bussinessHourlyWage',
              departList: []
          };
      },
      created() {
        this.getHourlyWagePermission();
      },
      mounted(){
        userApi.getDepartmentPageList({ size: 99, page: 0 }).then(res=>{
            this.departList = res.content.map(item=>{
                return {...item, label: item.name, value: item.name}
            })
        })
      },
      methods: {
        // 岗位时薪根据权限动态渲染， v-permission失效替代方案
        getHourlyWagePermission() {
          const userPermissionBtns = this.$store.getters && this.$store.getters.userPermissionBtns;
          const hasPermission = userPermissionBtns.includes(this.permissionCode.toLocaleLowerCase());
          hasPermission && this.labelList.splice(2, 0, { label: this.$t('billingPage.hourlyWage'), prop: 'hourlyWage', isCheck: true, disabled: false });
        },
        //   新增
        handleOpen(val) {
          if (!val) {
            this.title = this.$t('addText');
            this.form.id = null;
            this.form.department = null;
            this.form.position = null;
            this.form.hourlyWage = null;
          }else{
            this.title = this.$t('editText');
            this.form.id = val.id;
            this.form.department = val.department;
            this.form.position = val.position;
            this.form.hourlyWage = val.hourlyWage;
          }
          this.addDialogVisible = true;
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
        },
        onDelete(item){
            this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
                confirmButtonText: this.$t('toast.okText'),
                cancelButtonText: this.$t('toast.cancelText'),
                type: 'warning',
            }).then(()=>{
                userApi.modifyStation({...item, isDelete: 1}).then(res=>{
                    if (res.id || res._token || res.content || Array.isArray(res) || res.failed == false) {
                        this.$message.success(this.$t('toast.operationSuccessText'));
                        this.addDialogVisible = false;
                        this.reFresh();
                    }
                })
            })
        },
        submitForm(formName) {
          this.$refs[formName].validate(valid => {
            const data = {
              position: this.form.position,
              id: this.form.id,
              department: this.form.department,
              hourlyWage: this.form.hourlyWage,
            };
            if (valid) {
              if (this.form.id) {
                // 修改
                userApi.modifyStation({...data, isDelete: 0}).then(res=>{
                  if (res.id || res._token || res.content || Array.isArray(res) || res.failed == false) {
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    this.addDialogVisible = false;
                    this.reFresh();
                  }
                })
              } else {
                // 新增
                userApi.addStation(data).then(res=>{
                  if (res.id || res._token || res.content || Array.isArray(res) || res.failed == false) {
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    this.addDialogVisible = false;
                    this.reFresh();
                  }
                })
              }
            }
          });
        },
        handleClose() {
          this.addDialogVisible = false;
        },
      },
  };
  </script>

  <style scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
